import axios from 'axios';
import { generateToken } from './tokenGenerator.js';

export default class AwsCloudGateway {
  static async cancelUpdateAndCreateSubscription(
    subsToUpdate,
    subsToCancel,
    subsToCreate
  ) {
    const token = generateToken();
    const url = process.env.AWS_SERVICE_UPDATE_SUBS_URL;

    const body = {
      subsToUpdate,
      subsToCancel,
      subsToCreate
    };

    const headers = {
      Authorization: token,
      'Content-Type': 'application/json'
    };

    try {
      const response = await axios.post(url, body, { headers });
      return response.data;
    } catch (error) {
      console.error(
        'API call error:',
        error.response ? error.response.data : error.message
      );
      return;
    }
  }

  static async applyDiscount(subId) {
    const token = generateToken();
    const url = process.env.AWS_SERVICE_APPLY_DISCOUNT_URL;

    const body = {
      subscriptionId: `${subId}`
    };

    const headers = {
      Authorization: token,
      'Content-Type': 'application/json'
    };

    const response = await axios.post(url, body, { headers });
    return response.data;
  }

  static async getProductRecommendations(userId) {
    const token = generateToken();
    const queryParams = `userId=${userId}`;
    const url = process.env.FOB_SERVICE_PRODUCT_RECOMMENDATIONS_URL;
    const fullUrl = `${url}?${queryParams}`;

    const headers = {
      Authorization: token,
      'Content-Type': 'application/json'
    };

    const response = await axios.get(fullUrl, { headers });

    return response.data;
  }
}
